import { featuresCommon } from './featuresCommon';
import { FeaturesConfig } from "~/config/config";

export const featuresProd: FeaturesConfig = {
  ...featuresCommon,
  baseURL: "https://b2b-app.prod-gcp.fena.co",
  environment: "prod",

  app: {
    ...featuresCommon.app,
    appName: "fena-b2b-app",
  },

  cloudConfig: {
    provider: "gcp",
    gcp: {
      projectId: "prj-workload-prod",
      region: "europe-west2",
      integrationStorageBucket: "fena-integrations-api-prod",
      toolkitStorageBucket: "fena-toolkit-backend-prod",
      pubsub: {
        idMapSyncTopic: "batch-job-apps-id-maps-file-sync",
        bulkSyncTopic: "batch-job-apps-bulk-sync",
      },
    },
  },

  sentry: {
    dsn: "https://b82576884179ddf92e28130f43514e12@o1222258.ingest.us.sentry.io/4510467300655104",
  },
};
